// AuroraBackground — slow-panning, blurred color bands behind the hero.
// Structure borrowed from a reference "aurora" effect; recolored entirely
// in the Malinois palette (terracota / accentSoft / deep terra) instead of
// blue/indigo/violet, and toned way down (blur + low opacity + edge mask)
// so hero text stays the only protagonist and stays easy to read.
export function AuroraBackground({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <div
        className="aurora-layer absolute -inset-x-[10%] -inset-y-[25%] opacity-[0.13] mix-blend-multiply"
        style={{
          maskImage: "radial-gradient(ellipse 70% 55% at 50% 30%, black 15%, transparent 75%)",
          WebkitMaskImage: "radial-gradient(ellipse 70% 55% at 50% 30%, black 15%, transparent 75%)",
        }}
      />
    </div>
  );
}
